/**
 * FE-16: the table scrolls horizontally rather than breaking the layout. A table
 * that reflows into stacked cells stops being comparable, which is the whole
 * point of a column of numbers.
 *
 * Canonical usage:
 *   <Card className="overflow-hidden"><Table>…</Table></Card>
 */
export function Table({ children, className = '', flush = true, hover = false, minWidth = '42rem' }) {
  return (
    <div className="overflow-x-auto">
      <table
        className={['table', flush ? 'table-flush' : '', hover ? 'table-hover' : '', className].join(' ')}
        style={{ minWidth }}
      >
        {children}
      </table>
    </div>
  );
}

export const THead = ({ children }) => <thead>{children}</thead>;
export const TBody = ({ children }) => <tbody>{children}</tbody>;

export const TR = ({ children, className = '', ...props }) => (
  <tr className={className} {...props}>{children}</tr>
);

export const TH = ({ children, align = 'left', className = '' }) => (
  <th scope="col" className={`text-${align} ${className}`}>{children}</th>
);

export const TD = ({ children, align = 'left', className = '', ...props }) => (
  <td className={`text-${align} ${className}`} {...props}>{children}</td>
);

export default Table;
